import { Dispatch } from 'redux';
import { StudioAction, ReduxStudioActionType } from './model';
import { fetchGameList } from '../../../api/game';
import { GamesAction, ReduxGamesActionType } from '../games';
import { formatStudioList } from '../../../pages/game-content/lib/studio';
import { getCompanyInfo } from '../../../api';

// 获取工作室列表
export const getStudioList =
  (dispatch: Dispatch<StudioAction | GamesAction>) => async () => {
    const res = await fetchGameList();
    if (res) {
      const studioList = formatStudioList(res);
      await dispatch({
        type: ReduxStudioActionType.STUDIO_LIST,
        result: studioList,
      });
      await dispatch({
        type: ReduxGamesActionType.GET_GAMES,
        result: res,
      });
      return {
        studioList,
        gameList: res,
      };
    }
    return null;
  };

export const getStudioCert =
  (dispatch: Dispatch<StudioAction>) => async (studioId?: string) => {
    if (!studioId) {
      return null;
    }
    const res = await getCompanyInfo(studioId);

    await dispatch({
      type: ReduxStudioActionType.SET_CERT,
      result: { [studioId]: res },
    });

    return res;
  };
